import React from 'react'
import { EloBaseIcon, EloBaseIconProps } from '../_base'

export const EloFilterUpIcon: React.FC<EloBaseIconProps> = (props) => (
  <EloBaseIcon {...props}>
    <path fillRule='evenodd' clipRule='evenodd' d='M10 7L16 13H4L10 7Z' fill='currentColor' />
  </EloBaseIcon>
)
